<form (ngSubmit)="save()" [formGroup]="form">
    <div fxLayout="row" fxLayoutAlign="start center" mat-dialog-title>
        <h2 class="headline m-0" fxFlex="auto">My Profile</h2>

        <button
            class="text-secondary"
            mat-dialog-close
            mat-icon-button
            type="button"
        >
            <mat-icon [icIcon]="icClose"></mat-icon>
        </button>
    </div>

    <mat-divider class="-mx-6 text-border"></mat-divider>

    <mat-dialog-content fxLayout="column">
        <mat-form-field class="flex-auto">
            <mat-label>Email</mat-label>
            <input formControlName="email" matInput />

            <mat-icon [icIcon]="icPhone" class="mr-3" matPrefix></mat-icon>
        </mat-form-field>

        <mat-form-field class="flex-auto">
            <mat-label>Phone Number</mat-label>
            <input formControlName="phoneNumber" matInput />

            <mat-icon [icIcon]="icPhone" class="mr-3" matPrefix></mat-icon>
        </mat-form-field>

        <div class="flex-auto">
            <mat-label>Upload Profile Image</mat-label>
            <br /><br />
            <input type="file" />
        </div>

        <div class="flex flex-col sm:flex-row">
            <mat-form-field class="mt-6 flex-auto">
                <mat-label>New Password</mat-label>
                <input cdkFocusInitial formControlName="password" matInput />

                <!-- <mat-icon [icIcon]="icPerson" class="mr-3" matPrefix></mat-icon> -->
            </mat-form-field>

            <mat-form-field class="sm:mt-6 sm:ml-6 flex-auto">
                <mat-label>Confirm Password</mat-label>
                <input cdkFocusInitial formControlName="cpassword" matInput />

                <!-- <mat-icon [icIcon]="icPerson" class="mr-3" matPrefix></mat-icon> -->
            </mat-form-field>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close type="button">CANCEL</button>
        <button color="primary" mat-button type="submit">UPDATE DETAILS</button>
    </mat-dialog-actions>
</form>
